import { FC } from "react";

import "./ClientCardSkeleton.scss";

const ClientCardSkeleton: FC = () => {
  return (
    <div className="client-card-skeleton-v2">
      <div className="client-card-skeleton-v2__top">
        <div className="client-card-skeleton-v2__header">
          <div className="client-card-skeleton-v2__icon motif-skeleton-4" />
          <div className="client-card-skeleton-v2__status motif-skeleton-3" />
        </div>
        <div className="client-card-skeleton-v2__title motif-skeleton-12" />
        <div className="client-card-skeleton-v2__title--subline motif-skeleton-6" />
        <div className="client-card-skeleton-v2__title--sector motif-skeleton-10" />
      </div>
      <div className="client-card-skeleton-v2__bottom">
        <div className="client-card-skeleton-v2__team-members">
          <div className="client-card-skeleton-v2__avatar motif-skeleton-4" />
          <div className="client-card-skeleton-v2__avatar motif-skeleton-4" />
          <div className="client-card-skeleton-v2__avatar motif-skeleton-4" />
          <div className="client-card-skeleton-v2__total-count motif-skeleton-4" />
        </div>
        <div className="client-card-skeleton-v2__progress-bar motif-skeleton-12" />
      </div>
    </div>
  );
};

export default ClientCardSkeleton;
